import 'components/global/search-explore-nav/img/photos/term-bg-1.jpg';
import 'components/global/search-explore-nav/img/photos/term-bg-2.jpg';
import 'components/global/search-explore-nav/img/photos/term-bg-3.jpg';
import 'components/global/search-explore-nav/img/photos/term-bg-4.jpg';
import 'components/global/search-explore-nav/img/photos/term-bg-5.jpg';
import 'components/global/search-explore-nav/img/photos/term-bg-6.jpg';
import 'components/global/search-explore-nav/img/photos/term-bg-7.jpg';
import 'components/global/search-explore-nav/img/photos/term-bg-8.jpg';

import 'components/global/search-explore-nav/img/vectors/term-bg-1.jpg';
import 'components/global/search-explore-nav/img/vectors/term-bg-2.jpg';
import 'components/global/search-explore-nav/img/vectors/term-bg-3.jpg';
import 'components/global/search-explore-nav/img/vectors/term-bg-4.jpg';
import 'components/global/search-explore-nav/img/vectors/term-bg-5.jpg';
import 'components/global/search-explore-nav/img/vectors/term-bg-6.jpg';
import 'components/global/search-explore-nav/img/vectors/term-bg-7.jpg';
import 'components/global/search-explore-nav/img/vectors/term-bg-8.jpg';

import 'components/global/search-explore-nav/img/videos/term-bg-1.jpg';
import 'components/global/search-explore-nav/img/videos/term-bg-2.jpg';
import 'components/global/search-explore-nav/img/videos/term-bg-3.jpg';
import 'components/global/search-explore-nav/img/videos/term-bg-4.jpg';
import 'components/global/search-explore-nav/img/videos/term-bg-5.jpg';
import 'components/global/search-explore-nav/img/videos/term-bg-6.jpg';
import 'components/global/search-explore-nav/img/videos/term-bg-7.jpg';
import 'components/global/search-explore-nav/img/videos/term-bg-8.jpg';
